import collegeImage from '../assets/images/college.png'; // Adjust the path as needed

const AboutSection = () => {
  
  return (
    <section className="ftco-section ftco-no-pt ftco-no-pb"> 
      <div className="container">
      <div className="row justify-content-center mt-3 pb-4">
          <div className="col-md-8 text-center heading-section ftco-animate">
            <h2 className="mb-4 text-success">
              <span className="text-warning"> Kaamadhenu College  </span> of Education
            </h2>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-12">
            <div className="text px-4 position-relative">
              
              <h2 className="mb-4 text-primary"> About the College </h2>
              <p>  
       
              Kaamadhenu College of Education is an institution dedicated to the preparation of competent
and value oriented teachers. The college provides a supportive academic environment that
enables prospective teachers to acquire professional knowledge, pedagogical skills, and
appropriate professional values ​​required for effective teaching.
              </p>
              <div className="float-end ms-4 mb-3" style={{ maxWidth: '400px' }}>
                <img src={collegeImage} alt="Kaamadhenu College of Education" className="img-fluid" width={400} height={200} />
              </div>
              <p>
              The college was established in 2015 by Shri R. Perumalsamy, a philanthropist and
agriculturist with a strong commitment to the advancement of education for societal
development. Kaamadhenu College of Education is affiliated with Tamil Nadu Teachers
Education University (TNTEU) and is recognized by the National Council for Teacher
Education (NCTE).
              </p>
              <p>
              The institution is guided by the vision of nurturing well integrated teachers who can
contribute meaningfully to society. The management believes that teachers play a significant
role in shaping individuals and society through responsible and effective teaching practices.
              </p>
              <p>
              The two year Bachelor of Education (B.Ed.) program offered by the college is conducted in
accordance with the curriculum, norms, and regulations prescribed by Tamil Nadu Teachers
Education University and the National Council for Teacher Education. The program includes
both theoretical and practical components as mandated by the University.
              </p>
              <p>
              The college is located in a calm and eco friendly campus that supports focused academic
engagement. It is equipped with essential infrastructure including subject laboratories, a well
equipped library, and technology supported classrooms to facilitate effective teaching
learning processes.
              </p>
              <p>
              The institution gives due importance to student welfare by providing facilities such as
separate hostels for men and women, transport services, and necessary safety measures to
ensure a secure and conducive learning environment. Various academic and co curricular
clubs and committees function actively on the campus to promote leadership qualities,
creativity, social responsibility, and professional development among student teachers.
              </p>
            </div>
          </div>
      </div>    
      </div>
      <hr className="custom-hr"/>
    </section>
  );
};

export default AboutSection;
